<template>
  <!--
    Histórico do Diário de Auxiliares (#7286, Cenário 6).

    Mesmo layout do histórico do Diário Online (EDrawerHistoricoAulaLancada): drawer à
    direita, cabeçalho azul e um bloco por lançamento com as operações auditadas.
  -->
  <v-navigation-drawer width="30%" v-model="localDrawer" right temporary app>
    <v-list-item class="blue">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium white--text">
          Histórico de atendimentos lançados
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list v-if="!atendimentos.length" class="px-3" dense>
      <v-list-item-title>
        <strong class="subtitle-1 text-caption">Nenhum atendimento lançado neste vínculo</strong>
      </v-list-item-title>
    </v-list>

    <v-list
      v-for="atendimento in atendimentos"
      :key="atendimento.id"
      :id="`historico-atendimento-${atendimento.id}`"
      class="px-3"
      dense
    >
      <v-list-item-title>
        <p class="font-weight-light subtitle-1 text-caption">
          <strong>Conteúdo : </strong>
          <span>{{ atendimento.conteudo ? atendimento.conteudo : "- - -" }}</span>
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p class="font-weight-light subtitle-1 text-caption">
          <strong>Data do atendimento: </strong>
          <span>{{ atendimento.data_formatada ? atendimento.data_formatada : "- - -" }}</span>
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p class="font-weight-light subtitle-1 text-caption">
          <strong>Operações: </strong>
        </p>
      </v-list-item-title>

      <div v-if="atendimento.audits.length > 0">
        <v-list v-for="(audit, index) in atendimento.audits" :key="audit.id" class="px-3" dense>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              Nome:
              <strong>{{ audit.username ? audit.username : "- - -" }}</strong>
            </p>
          </v-list-item-title>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              Tipo de operação:
              <strong>{{ audit.event ? events[audit.event] : "- - -" }}</strong>
            </p>
          </v-list-item-title>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              Data da operação:
              <strong>{{ audit.created_at ? dateFormat(audit.created_at) : "- - -" }}</strong>
              <strong>
                às {{ audit.created_at ? dateFormatHour(audit.created_at) : "- - -" }}</strong
              >
            </p>
          </v-list-item-title>
          <v-divider v-if="index + 1 != atendimento.audits.length"></v-divider>
        </v-list>
      </div>
      <v-list-item-title v-else>
        <strong class="subtitle-1 text-caption">Operações não encontradas</strong>
      </v-list-item-title>

      <v-list-item-title class="mt-2">
        <v-list-item-content>
          <v-divider></v-divider>
        </v-list-item-content>
      </v-list-item-title>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { dateFormat, dateFormatHour } from "@/plugins/filters";

export default {
  name: "EDrawerHistoricoAtendimentos",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    gestaoId: {
      type: [Number, String],
      required: true,
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    async localDrawer() {
      this.$emit("input", this.localDrawer);
      if (this.localDrawer) {
        await this.carregarHistorico();
      }
    },
  },
  data() {
    return {
      localDrawer: this.value,
      atendimentos: [],
      dateFormat,
      dateFormatHour,
      events: {
        created: "Criado",
        updated: "Atualizado",
        deleted: "Deletado",
        restored: "Restaurados",
      },
    };
  },
  methods: {
    async carregarHistorico() {
      this.$loaderService.open("Carregando histórico");
      try {
        const response = await this.$services.atendimentosAuxiliaresService.historico(
          this.gestaoId
        );

        this.atendimentos = response.historicoLancamento || [];
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
